import React from "react";
import { Badge } from "../ui/badge";
import { getShortTicketClass, getSegmentTicketClass } from "../../utils/ticketClass";

/**
 * Inline ticket / cabin-class pill for transit segments.
 *
 * Renders nothing when:
 *   - the segment has no ticket_class / cabin_class set, OR
 *   - the segment type doesn't map to a short label
 *     (only flights and trains do today).
 *
 * The visual is intentionally identical to the chip rendered in
 * ItineraryView.js so the cue is consistent across collapsed + expanded
 * views. Hover-tooltip shows the full ("Economy" / "Premium Economy" /
 * "Business" / "First") value.
 */
export const CabinClassBadge = ({ segment, className = "" }) => {
  const fullValue = getSegmentTicketClass(segment);
  const shortLabel = getShortTicketClass(fullValue, segment?.type);
  if (!shortLabel) return null;
  return (
    <Badge
      variant="outline"
      className={
        "flex-shrink-0 text-[10px] px-1.5 py-0 bg-indigo-50 dark:bg-indigo-950/40 " +
        "text-indigo-700 dark:text-indigo-300 border-indigo-200 dark:border-indigo-800 " +
        className
      }
      data-testid={`segment-class-badge-${segment?.id || "unknown"}`}
      title={`Class: ${fullValue}`}
    >
      {shortLabel}
    </Badge>
  );
};

export default CabinClassBadge;
